import React from "react";
import Button from "../../components/button";
import { useScreenSize } from "../../hooks/useScreenSize";
import illustrationEnemAction from "../../assets/illustration-enem-action.png";
import illustrationExperimenteSeuBrilho from "../../assets/illustration-experimente-seu-brilho.png";

import * as S from "./styles";

const SectionExtra = () => {
	const dimension = useScreenSize();

  return (
    <S.SectionExtra id="toExtra" data-section="section_extra">
      <div className="container">
        <div className="card-extra enem-action border">
          <div className="info">
            <h2>Turbine sua rotina de estudos com o ENEM ACTION!</h2>
            <p>
              O <b>ENEM ACTION</b> é uma plataforma de estudos com simulados, testes 
              vocacionais, aulas ao vivo e tudo o que precisa para evoluir seu 
              conhecimento. E tudo isso de graça.
            </p>
            <Button
              label="SUBA DE NÍVEL COM O ENEM ACTION"
              fontSize={dimension.width >= 1024 ? "23" : "20"}
              height='86'
              width={dimension.width >= 1024 ? "533" : "234"}
              padding={dimension.width >= 1024 ? "0" : "25"}
              weight={900}
              dataElement="button_enem-action"
              action={() => {window.open('https://enemaction.com.br/?utm_source=enemverso&utm_medium=enem-action&utm_term=botao-lp', '_blank')}}
            />
          </div>
          <img src={illustrationEnemAction} alt="Enem Action" />
        </div>

        <div className="card-extra experimente-seu-brilho border">
          <div className="info">
            <h2>EXPERIMENTE SEU BRILHO</h2>
            <p>
            Na dúvida de qual carreira seguir? Acesse a plataforma gratuita <b>Experimente seu Brilho</b>, 
            teste diversos cursos de graduação e derrote o Chefão da Dúvida.
            </p>
            <Button
              label="EXPERIMENTE SEU BRILHO"
              fontSize={dimension.width >= 1024 ? "23" : "20"}
              height='86'
              width={dimension.width >= 1024 ? "393" : "234"}
              padding={dimension.width >= 1024 ? "0" : "25"}
              weight={900}
              dataElement="button_experimente-seu-brilho"
              action={() => {window.open('https://experimenteseubrilho.com.br/?utm_source=enemverso&utm_medium=experimente-seu-brilho&utm_term=botao-lp', '_blank')}}
            />
          </div>
          <img src={illustrationExperimenteSeuBrilho} alt="Experimente seu brilho" />
        </div>
      </div>
    </S.SectionExtra>
  );
};

export default SectionExtra;
